<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ sidebarHeader }}</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      ref="sidebarScrollArea"
      class="vs-con-loading__container scroll-area--data-list-add-new pt-4 pb-6"
      :settings="settings"
    >
      <div ref="subtype">
        <ul class="flex flex-wrap items-center justify-center pb-4">
          <li>
            <vs-radio
              v-model="formData.videoTypeId"
              color="#0074BE"
              vs-value="1"
              class="pr-10"
              >Upload</vs-radio
            >
          </li>
          <li>
            <vs-radio
              v-model="formData.videoTypeId"
              color="#13B8EB"
              vs-value="2"
              class="pr-10"
              >Vimeo</vs-radio
            >
          </li>
          <li>
            <vs-radio
              v-model="formData.videoTypeId"
              color="#FE0000"
              vs-value="3"
              class="pr-10"
              >Youtube</vs-radio
            >
          </li>
          <li>
            <vs-radio
              v-model="formData.videoTypeId"
              color="primary"
              vs-value="4"
              >External</vs-radio
            >
          </li>
        </ul>
      </div>
      <div class="pl-6 pr-6 pb-6">
        <div>
          <label>Name</label>
          <vs-input
            autocomplete="off"
            v-validate="'required'"
            name="Name"
            v-model="formData.name"
            class="w-full"
          />
          <span class="text-danger text-sm" v-show="errors.has('Name')">{{
            errors.first("Name")
          }}</span>
        </div>

        <div :class="formData.videoTypeId == 1 ? 'pt-4 pb-6' : 'pt-4'">
          <label>Description</label>
          <vs-textarea
            id="xxx"
            v-model="formData.description"
            class="w-full white_border"
          />
        </div>

        <div v-show="formData.videoTypeId == 1">
          <div class="flex flex-wrap items-center justify-center">
            <vs-button
              size="huge"
              radius
              :color="gradientColor1"
              :gradient-color-secondary="gradientColor2"
              type="gradient"
              icon-pack="feather"
              icon="icon-video"
              v-show="formData.uploadedFileName"
              @click="showUpload"
              width="100%"
            ></vs-button>
          </div>
          <div
            class="flex vs-con-loading__container flex-wrap items-center justify-center pb-4"
          >
          </div>
          <file-pond
                  id="filepond"
                  ref="pond"
                  :server="uploadLocation"
                  :name="'file'"
                  label-idle="Drop video here or <span class='filepond--label-action'>Browse</span>"
                  :allow-multiple="false"
                  accepted-file-types="video/mp4, video/MP4"
                  :instant-upload="true"
                  allowPaste=false
                  :allow-image-preview="true"
                  @addfilestart="beforeUpload"
                  @processfilestart="startUpload"
                  @processfileprogress="uploadProgress"
                  @processfile="uploadComplete"
                  @removefile="fileRemoved"
              />
        </div>
        <div
          v-show="
            formData.videoTypeId == 2 ||
              formData.videoTypeId == 3 ||
              formData.videoTypeId == 4
          "
        >
          <div class="mb-3">
            <label v-if="formData.videoTypeId == 2">Vimeo Video URL</label>
            <label v-else-if="formData.videoTypeId == 3"
              >YouTube Video URL</label
            >
            <label v-else>External Video URL</label>
            <vs-input
              autocomplete="off"
              v-model="formData.uploadedFileName"
              class="w-full"
            />
            <small v-if="formData.videoTypeId == 2"
              >example: https://vimeo.com/398743632</small
            >
            <small v-else-if="formData.videoTypeId == 3"
              >example: https://youtu.be/SUWg47xY660</small
            >
          </div>
          <div>
            <label>Reviewer</label>
            <v-select
              ref="reviewerDropdown"
              class="w-full style-chooser"
              placeholder="Search / Select Reviewer"
              :options="reviewers"
              v-model="reviewerDropdown"
            ></v-select>
          </div>

          <div v-show="$siteTypeId() == 1">
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-divider>Module Assignment</vs-divider>
              </div>
            </div>

            <div>
              <label>Select Subject</label>
              <v-select
                @search:blur="getModules"
                ref="courseDropdown"
                class="w-full style-chooser"
                placeholder="Search / Select Course"
                :options="courses"
                v-model="courseDropdown"
              ></v-select>
            </div>
            <div class="mt-3" v-if="courseDropdown">
              <label>Select Topic</label>
              <v-select
                @search:blur="addModule"
                ref="moduleDropdown"
                class="w-full style-chooser"
                placeholder="Search / Select Module"
                :options="modules"
                v-model="moduleDropdown"
              ></v-select>
            </div>
            <div class="mt-3">
              <vs-table
                ref="selectedModulesTable"
                class="vs-con-loading__container"
                stripe
                single
                max-items="100"
                :data="selectedModules"
              >
                <template slot="thead">
                  <vs-th sort-key="studentFullName">Module</vs-th>
                  <vs-th></vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="module"
                    :key="moduleIndex"
                    v-for="(module, moduleIndex) in data"
                  >
                    <vs-td :data="data[moduleIndex].label">
                      {{ module.label }}
                    </vs-td>

                    <vs-td>
                      <vs-button
                        color="danger"
                        type="flat"
                        icon-pack="feather"
                        icon="icon-x"
                        @click.stop.prevent="removeModule(module.value)"
                      ></vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>

        <vs-checkbox v-model="formData.isMarketingMaterial" class="mt-4 w-full"
          >Marketing Material</vs-checkbox
        >
      </div>
    </VuePerfectScrollbar>

    <div
      class="flex flex-wrap items-center justify-center pb-4 pt-1"
      slot="footer"
    >
      <vs-button
        class="mr-4 vs-con-loading__container cursor-pointer"
        color="success"
        @click="updateApproach"
       
        ref="addupdateButton"
        >{{ buttoncaption }}</vs-button
      >
      <vs-button
        color="danger"
        class="mr-4 vs-con-loading__container cursor-pointer"
        v-show="formData.id"
        @click="deleteVideo"
        ref="deleteButton"
        >Delete</vs-button
      >
      <vs-button
        type="border"
        class="ml-4 cursor-pointer"
        color="warning"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import  vueFilePond, {setOptions } from 'vue-filepond';
import FilePondPluginFileRename from 'filepond-plugin-file-rename';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview,FilePondPluginFileRename);
    setOptions({
    fileRenameFunction: (file) => {
      var siteName = "Temp";
      if(localStorage.getItem('userSiteInfo') != ""){
        if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
          siteName = JSON.parse(localStorage.getItem('userSiteInfo'))[0].name;
        else 
          siteName = JSON.parse(localStorage.getItem('userSiteInfo')).name;
      }
        var randomString = Date.now();
        var dateObj = new Date();
        var year = dateObj.getUTCFullYear();
        var month = (dateObj.getUTCMonth() + 1).toString(); 
        var newBaseName = file.basename.replaceAll('#','');
        return siteName + "_Auto~" + year + "_" +  "00".substring(0, 2 - month.length) + month + "~" + newBaseName + "_" + randomString + file.extension;
    }});


export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    selectedVideo: {
      type: Object,
      required: false
    },
    buttoncaption: {
      type: String,
      required: false
    },
    sidebarHeader: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      backgroundLoading: "#fff",
      gradientColor1: "#c72a75",
      gradientColor2: "#5252e8",
      formData: {
        id: 0,
        name: "",
        description: "",
        uploadedFileName: "",
        isUsed: false,
        videoTypeId: 1,
        reviewerId: null,
        creatorId: null,
        isMarketingMaterial: false,
        modules: []
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      isLoading: false,
      reviewerDropdown: 0,
      courseDropdown: 0,
      moduleDropdown: 0,
      reviewers: [],
      courses: [],
      modules: [],
      selectedModules: []
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.initValues();
        }
      }
    },
    server(){
      return {
        url: 'https://content.digicampus.co.za/scripts/',
        process: {
          url: 'tue4VGmEsLhfsy43X8WBemZ5UnTzLDuD2.php',
        },
      };
    },
    uploadLocation: {
      get() {
        return this.$buildUrl("tempupload");
      }
    },
    isDisabled: function() {
      return !this.formData.uploadedFileName;
    }
  },
  watch: {
    isSidebarActive: function(val) {
      if (val) {
        var self = this;
        self.getReviewers();
        self.getCourses();
        if (self.selectedVideo.id) {
          self.formData.id = self.selectedVideo.id;
          self.formData.name = self.selectedVideo.name;
          self.formData.description = self.selectedVideo.description;
          self.formData.uploadedFileName = self.selectedVideo.videoUrl;
          self.formData.isUsed = self.selectedVideo.isUsed;
          self.selectedModules = self.selectedVideo.modules.map(function(item) {
            return { label: item.text, value: item.value };
          });
          self.formData.videoTypeId = self.selectedVideo.videoTypeId;
          self.formData.isMarketingMaterial =
            self.selectedVideo.isMarketingMaterial;
        } else {
          self.initValues();
        }
      }
    }
  },
  methods: {
    initValues() {
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.description = "";
      this.formData.uploadedFileName = "";
      this.formData.videoTypeId = 1;
      this.formData.reviewerId = null;
      this.formData.creatorId = null;
      this.formData.isMarketingMaterial = false;
      this.reviewerDropdown = 0;
      this.courseDropdown = 0;
      this.moduleDropdown = 0;
      this.selectedModules = [];
      this.formData.modules = [];
      this.isLoading = false;
      this.errors.clear();
    },
    beforeUpload(file) {
      
    },
    startUpload(file) {
      
    },
    uploadProgress(file, progress) {
      
    },
    fileRemoved(error, file) {
      this.initValues();
    },
    uploadComplete(error, file) {
      if(file.serverId)
      {
        this.uploadedFileUrl = JSON.parse(file.serverId).url;
        this.formData.uploadedFileName =  JSON.parse(file.serverId).url;
      }
    },
    getReviewers() {
      var self = this;
      self.showLoadingOnElement("sidebarScrollArea", 1, "corners");

      var onSuccess = response => {
        self.reviewers = response.data.map(item => {
          return { label: item.text, value: item.value };
        });
        if (self.formData.id && self.formData.videoTypeId == 2)
          self.reviewerDropdown = self.reviewers.filter(function(item) {
            return item.value == self.selectedVideo.reviewerId;
          })[0];
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.sidebarScrollArea.$el);
      };

      self.$ajaxGet(self, "Video/ListReviewers", onSuccess, onFinally);
    },
    getCourses() {
      var self = this;
      self.showLoadingOnElement("sidebarScrollArea", 1, "corners");

      var onSuccess = response => {
        self.courses = response.data.map(item => {
          return { label: item.text, value: item.value };
        });
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.sidebarScrollArea.$el);
      };

      self.$ajaxGet(self, "Course/GetSelectList", onSuccess, onFinally);
    },
    getModules() {
      var self = this;
      if (self.courseDropdown) {
        self.showLoadingOnElement("sidebarScrollArea", 1, "corners");

        var onSuccess = response => {
          self.modules = [];
          self.moduleDropdown = 0;
          self.modules = response.data.map(item => {
            return { label: item.text, value: item.value };
          });
        };
        var onFinally = function() {
          self.$vs.loading.close(self.$refs.sidebarScrollArea.$el);
        };

        self.$ajaxGet(
          self,
          "Module/GetSelectList/" + self.courseDropdown.value,
          onSuccess,
          onFinally
        );
      }
    },
    addModule() {
      var self = this;
      var exists = false;

      if (self.moduleDropdown) {
        for (var i = 0; i < self.selectedModules.length; i++) {
          if (self.selectedModules[i].value == self.moduleDropdown.value) {
            exists = true;
            break;
          }
        }

        if (!exists) {
          self.selectedModules.push(self.moduleDropdown);
        }
      }
    },
    removeModule(moduleId) {
      this.selectedModules = this.selectedModules.filter(function(item) {
        return item.value != moduleId;
      });
    },
    saveData() {
      this.$emit("saveData");
      this.$vs.loading.close(this.$refs.addupdateButton.$el);
    },
    addEditVideo() {
      this.clearFilepond();
      if (!this.formData.uploadedFileName) {
        this.$vs.notify({
          title: "Attention",
          color: "danger",
          text: "Please upload a file.",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-upload"
        });
        return;
      }

      this.$validator.validateAll().then(result => {
        var self = this;
        if (result) {
          self.showLoadingOnButton();
          if (self.formData.isUsed) self.showLoadingOnList();

          self.formData.modules = self.selectedModules.map(function(item) {
            return item.value;
          });
          self.formData.reviewerId = self.reviewerDropdown
            ? parseInt(self.reviewerDropdown.value)
            : null;

          var onSuccess = response => {
            self.saveData();
            self.$vs.notify({
              title: "Information",
              color: "success",
              text: "Video Saved",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-save"
            });
          };
          var onFinally = function() {
            self.$vs.loading.close(self.$refs.addupdateButton.$el);
            self.$vs.loading.close(self.$parent.$el);
          };

          self.$ajaxPost(self, "Video/AddVideoAsTeacher", self.formData, onSuccess, onFinally);
        } else {
          self.$vs.notify({
            title: "Attention",
            color: "warning",
            text: self.$validator.errors[0].item.msg,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-info"
          });
        }
      });
    },
    showUpload() {
      this.formData.uploadedFileName = null;
    },
    deleteVideo() {
      var self = this;
      self.showLoadingOnDeleteButton();

      var onSuccess = response => {
        self.saveData();
        self.initValues();
        self.$vs.notify({
          title: "Information",
          color: "success",
          text: "Video Deleted",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-trash"
        });
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
      };

      self.$ajaxDelete(self, "video/" + self.formData.id, onSuccess, onFinally);
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    showLoadingOnButton() {
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.addupdateButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnDeleteButton() {
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.deleteButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnList() {
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$parent.$el,
        scale: 1
      });
    },
    showLoadingOnUploader() {
      var self = this;
      self.isLoading = true;
      self.$vs.loading({
        type: "material",
        container: self.$refs.fileUpload.$el,
        scale: 0.45
      });
    },
    updateApproach() {
      if (this.formData.isUsed && this.formData.id) this.openConfirm();
      else this.addEditVideo();
    },
    openConfirm() {
      this.$emit("closeSidebar");
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `Attention`,
        text:
          "The selected video is being used in one or more video task(s).\n\nAre you sure you want to update it?",
        accept: this.addEditVideo,
        acceptText: "Yes, update",
        cancelText: "No, cancel"
      });
    },
    clearFilepond(){
        var self = this;
        if(this.$refs.pond){
          self.$refs.pond.getFiles().forEach(element => {
            self.$refs.pond.removeFile(element);
          });
        }
      },
  },
  mounted() {
    var self = this;
    // self.$refs.fileUpload.$el.addEventListener("click", function() {
    //   if (!self.isLoading) self.showLoadingOnUploader();
    //   else {
    //     self.isLoading = false;
    //     self.$vs.loading.close(self.$refs.fileUpload.$el);
    //   }
    // });
  },
  components: {
    FilePond,
    VuePerfectScrollbar,
    "v-select": vSelect
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
    .img-upload {
      margin-top: 2rem;
      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}

.filepond--panel-root {
  border-radius: 0 6px 6px 0;
  background-color: rgba(255, 255, 255, 0) !important;
}

.filepond--drop-label {
  color:rgb(202, 202, 202) !important;
}
</style>
